<template>
<div id="container" class="container djgeschichten">
  <div class="fullscreen_background">
    <img src="/static/assets/djgeschichten/Hintergrund_2860.jpg" />
  </div>

  <!-- <schnee :amount="200" :size="4" :speed="0.5" :wind="0" :opacity="0.8" :swing="0.5" :image="null" :zIndex="null" :resize="true" color="#fff" /> -->
  <top-logo />
  <stoppuhr />
  <lautsprecher />
  <copyright />
  <top-menu />
  <hintergrundbutton />
  <!-- Figuren -->
  <div class="discokugel discokugel_erscheint z4">
    <!-- <img src="/static/assets/djgeschichten/DJ_Hugi_2880zu1620_04-01.png" class="img" /> -->
	  <div class="discokugel_animation"></div>
  </div>
  <div class="hugi z4">
    <!-- <img src="/static/assets/djgeschichten/Hugi.png" class="img" /> -->
    <div class="hui_animation"></div>
  </div>
  <div class="dubix z4">
    <img src="/static/assets/djgeschichten/Dubix.png" class="img" />
  </div>
  <div class="tina z4">
    <img src="/static/assets/djgeschichten/Tina.png" class="img" />
  </div>
  <div class="gigi z4">
    <img src="/static/assets/djgeschichten/Gigi.png" class="img" />
  </div>
  <!-- <div class="prinz z4 hui_animation ">
    <img src="/static/assets/djgeschichten/Prinz.png" class="img" /> 
  </div> -->
  <!-- <div class="buch z4">
        <img src="/static/assets/djgeschichten/Buch.png" class="img" />
    </div> -->
  <!-- <div class="schneemann z4">
        <img src="/static/assets/djgeschichten/Schneemann.png" class="img" />
    </div>
    <div class="schlitten z4">
        <img src="/static/assets/djgeschichten/Schlitten.png" class="img" />
    </div> -->
  <div class="libero z4">
    <img src="/static/assets/djgeschichten/Libero.png" class="img" />
  </div>
  <div class="rolle z4">
    <!-- <img src="/static/assets/djgeschichten/Rolle_.png" class="img" /> -->
  <div class="rolle_animation"></div>
	</div>
  <div class="schiller z4">
     <!--<img src="/static/assets/djgeschichten/Schiller.png" class="img" /> -->
	  <div class="schiller_animation"></div>
  </div>
  <div class="vogel z4">
     <!--<img src="/static/assets/djgeschichten/Vogel.png" class="img" /> -->
	  <div class="vogel_animation"></div>
  </div>
  <div class="publikum z30">
    <img src="/static/assets/djgeschichten/DJ_Hugi_2880zu1620_02-01.png" class="img" />
  </div>
  <div class="lichter z3">
    <div class="lichter_animation"></div>
  </div>
  <router-link to="/skigeschichten" tag="div" class="pfeil_links_big z50 pointer">
    <img class="img" src="/static/assets/djgeschichten/Pfeil.png" />
  </router-link>
  <router-link tag="div" to="zirkusgeschichten" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/djgeschichten/Pfeil-1.png" />
    </router-link>
  <div class="geschichte z50">
    <img src="/static/assets/djgeschichten/DJ Hugi.png" usemap="#geschichte-map">
    <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichte_2_DJ_Hugi.mp3" jsonurl="/static/assets/geschichten/hugi_28_11.timings.json" content=".djgeschichten" target="djgeschichten_target" />
    <vuescrollbar tag="div" class="fliesstext" id="djgeschichten_target">
      <p>Aufgeregt ging DJ Hugi den Weg zur Schule. Heute Abend würde dort die große Contest-Party steigen und seine Band „Heydubies“ würde auftreten. Monatelang hatten sie für diesen Tag geübt und sich einen coolen Hip-Hop-Song ausgedacht. Dr. D. Dubix hatte für den Text gesorgt und er, DJ Hugi, sowie Lady Gigi für die Musik. Doch keiner der drei hatte eine Idee, wie man Hip-Hop tanzt. Wie immer wusste die kluge Lady Gigi Rat und fragte ihre Mitschülerin Tina Talente, die alles über Hip-Hop wusste.</p>
      <p>Lady Gigi konnte das schüchterne Mädchen überreden, mitzumachen. Jetzt hatten die „Heydubies“ auch eine tolle Tanznummer und Tina Talente war bei den „Heydubies“ gar nicht mehr schüchtern.</p>
      <p>DJ Hugi freute sich auf den Contest. Die Jury würde aus ihrem Musiklehrer Herrn Vogel, der Sportlehrerin Frau Rolle und dem Deutschlehrer Herrn Schiller bestehen. DJ Hugi rechnete sich große Chancen auf einen Preis aus. Denn seine Band hatte nicht nur einen Megaauftritt, sondern auch einen Superstar: Dog Libero!</p>
        <p>Um vier Uhr wollten sich die „Heydubies“ treffen und um sechs Uhr würde ihr Auftritt beginnen. Doch als DJ Hugi gut gelaunt die Garderobe betrat, saßen dort eine weinende Tina Talente, ein trauriger Dr. D. Dubix und eine — oh Wunder! — ratlose Lady Gigi. „Was ist los?“, fragte DJ Hugi. „Ist etwas Schlimmes passiert?“ Tina Talente schluchzte: „Nein, eigentlich nicht. Aber ich habe plötzlich solche Angst vor dem Auftritt! Ich trau mich das nicht. Ihr müsst das alleine machen!“</p>
        <p>„Aber“, entgegnete DJ Hugi, „du bist total wichtig! Ohne dich kriegen wir das nie hin! Komm, du schaffst das!“ „Nein, niemals!“, stieß Tina unter Tränen hervor. „Ach, ich bin so eine schlechte Freundin!“</p>
        <p>Dog Libero winselte, sprang auf Tinas Schoß und leckte ihr die Tränen ab. „Siehst du, Tina“, tröstete Dr. D. Dubix Tina freundlich, „Libero findet auch, dass du Quatsch erzählst. Natürlich bleibst du auch unsere Freundin, wenn du einmal Angst ...“ „Gigi“, unterbrach ihn DJ Hugi, „weißt du noch, als ich klein war und mich nicht traute, im Schwimmkurs ins Wasser zu springen?“</p>
        <p>Lady Gigi sah ihn an. „Das Buch mit den Geschichten, die Mut machen! Warum bin ich nicht selbst darauf gekommen?“, rief sie verwundert und schaute DJ Hugi nach, der schon losgeeilt war.</p>
        <p>Zwei Stunden später tobte das Publikum in der Schulturnhalle. Denn die fünf „Heydubies“ zeigten, was sie draufhatten. Jetzt kam das Solo von Dog Libero: Der kleine Hund rannte los, machte viereinhalb Purzelbäume, blieb auf dem Rücken liegen und drehte sich wie ein Turbokarussell! Wow! Was für Power-Moves! Der Song war zu Ende und der Applaus riesig. Herrn Schiller fehlten die Worte, Herr Vogel pfiff auf den Fingern und Frau Rolle war total von der Rolle. Tina Talente strahlte. Doch was war in der Garderobe passiert? DJ Hugis Geschichten hatten erst Tina Talentes Tränen versiegen und sie lächeln lassen. Dann hatte sie laut verkündet: „Was andere schaffen, schaffe ich auch!“ Schließlich war die Band Hand in Hand auf die Bühne gegangen und jetzt stand sie vor einem begeisterten Publikum.</p>
        <p>Spät am Abend überreichte die Jury den „Heydubies“ den ersten Preis. Danach sprach jedes Bandmitglied etwas ins Mikro. DJ Hugi, Lady Gigi und Dr. D. Dubix bedankten sich bei allen, die ihnen geholfen hatten, Dog Libero bellte: „Wuff!“ Und als Tina Talente an der Reihe war, rief sie mit fester Stimme: „Ich möchte etwas ganz Wichtiges sagen: </p>
        <p><span>Das Lesen ist schön!</span></p>
    </vuescrollbar>
  </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
/* eslint whitespace: "off" */
/* eslint indent: "off" */
/* eslint keyword-spacing: "off" */


import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'djgeschichten',
  data () {
    return {
      who: 'djgeschichten'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'player': Player,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)
    var muted = (typeof this.$root.muted === 'undefined'? false : this.$root.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Hugi_Titel_A1902.mp3')
      window.currentAudioX.muted = (typeof window.muted !== 'undefined' ? window.muted : false)
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }

      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_dj_Atmo_pur.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false)
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e) {
        window.bgsounddisabled = true

      }
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
      console.log('hintergrundsound nicht aktiv')
    }

  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

/*djgeschichten */

.djgeschichten {
  position: absolute;
  width: 1920px;
  height: 1080px;
  bottom: 0;
}

.djgeschichten .himmel {
  display: block !important;
}

.djgeschichten .geschichte {
  position: absolute;
    top: 187px;
    left: 52%;
}

.djgeschichten .libero {
    position: absolute;
    top: 51%;
    left: 15%;
}

.djgeschichten .buch {
  position: absolute;
  bottom: 6vh;
  left: 22.393939393939%;
}

.djgeschichten .dubix {
  position: absolute;
    top: 31.018519%;
    left: 12.747475%;
}

.djgeschichten .dubix {
  animation: dubix_erscheint 0.5s ease-out;
  animation-delay: 1s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes dubix_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.djgeschichten .rolle {
  animation: rolle_erscheint 0.5s ease-out;
  animation-delay: 1.5s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes rolle_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.djgeschichten .vogel {
  animation: vogel_erscheint 0.5s ease-out;
  animation-delay: 2s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}
.djgeschichten .schiller {
  animation: schiller_erscheint 0.5s ease-out;
  animation-delay: 2.5s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes schiller_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes vogel_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.djgeschichten .tina {
  position: absolute;
    top: 34.018519%;
    left: 42.828283%;
}

.djgeschichten .tina {
  animation: tina_erscheint 0.5s ease-out;
  animation-delay: 3s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes tina_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.djgeschichten .gigi {
  position: absolute;
    top: 35.018519%;
    left: 31.69697%;
}

.djgeschichten .gigi img {
  animation: gigi_erscheint 1s;
  animation-delay: 3s;
  animation-fill-mode: forwards;
  transform-origin: bottom center;
  /* margin-left: 100px; */
  opacity: 0;
}
.djgeschichten .hugi {
    position: absolute;
    top: 26.018519%;
    left: 20.545455%;
}
	.djgeschichten .rolle {
    position: absolute;
    top: 72%;
    left: 16%;
}
	.djgeschichten .schiller {
    position: absolute;
    top: 68%;
    left: 27%;
}
	.djgeschichten .vogel {
    position: absolute;
    top: 66%;
    left: 39%;
}
@keyframes gigi_erscheint {
  /* 0% {
    margin-left: 100px;
    opacity: 0;
  }
  100% {
    margin-left: 0;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.djgeschichten .discokugel {
  position: absolute;
    top: -29%;
    left: 32%;
}

.discokugel_erscheint {
  animation: discokugel_erscheint_flow 5s ease-out;
  animation-delay: 0.75s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes discokugel_erscheint_flow {
  0% {
    margin-top: -800px;
    opacity: 0;
  }
	20% {
		opacity: 1;
	}
  100% {
    margin-left: 0px;
    opacity: 1;
    margin-top: 0px;
  }
}

.djgeschichten .prinz {
  position: absolute;
  top: 61.018519%;
  left: 13.131313131313%;
}

.djgeschichten .schneemann {
  position: absolute;
  top: 66.018519%;
  left: 89.131313%;
}

.djgeschichten .schlitten {
  position: absolute;
  top: 57.018519%;
  left: 91.131313%;
}

.fliesstext {
  bottom: 26%;
  left: 13.5%;
  width: 79%;
  font-size: 16pt;
  font-family: 'Open Sans';
  font-weight: 400;
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 450px;
  padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering2
/* Safari and Chrome */

  {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  50% {
    -ms-transform: translate(0px, 50px);
    -moz-transform: translate(0px, 50px);
    -webkit-transform: translate(0px, 50px);
    -o-transform: translate(0px, 50px);
    transform: translate(0px, 50px);
  }
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

@keyframes hovering2 {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  /* 25% {
    -ms-transform: translate(-20px,20px);
    -moz-transform: translate(-20px,20px);
    -webkit-transform: translate(-20px,20px);
    -o-transform: translate(-20px,20px);
    transform: translate(-20px,20px);
  }
 */
  50% {
    -ms-transform: translate(0px, 50px);
    -moz-transform: translate(0px, 50px);
    -webkit-transform: translate(0px, 50px);
    -o-transform: translate(0px, 50px);
    transform: translate(0px, 50px);
  }
  /*  75% {

    -ms-transform: translate(20px,50px);
    -moz-transform: translate(20px,50px);
    -webkit-transform: translate(20px,50px);
    -o-transform: translate(20px,50px);
    transform: translate(20px,50px);
  }
*/
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

.djgeschichten .hovering {
  -webkit-animation: hovering2 8s ease-in-out infinite;
  -moz-animation: hovering2 8s ease-in-out infinite;
  -ms-animation: hovering2 8s ease-in-out infinite;
  -o-animation: hovering2 8s ease-in-out infinite;
  animation: hovering2 8s ease-in-out infinite;
}


.hui_animation {
  width: 271px;
  height: 278px;
  background: url('/static/assets/djgeschichten/Hugi_2.png') top center;
  animation-delay: 2s;
  animation: play_hugi 4s steps(6) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes play_hugi {
  100% {
    background-position: 0 -1668px;
  }
}
.rolle_animation {
  width: 262px;
  height: 263px;
  background: url('/static/assets/djgeschichten/rolle_animation.png') top center;
  animation-delay: 2s;
  animation: play_rolle 4s steps(5) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes play_rolle {
  100% {
    background-position: 0 -1307px;
  }
}
.vogel_animation {
  width: 227px;
  height: 220px;
  background: url('/static/assets/djgeschichten/vogel_animation.png') top center;
  animation-delay: 2s;
  animation: play_vogel 4s steps(5) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes play_vogel {
  100% {
    background-position: 0 -1100px;
  }
}
	.discokugel_animation {
  width: 194px;
  height: 599px;
  background: url('/static/assets/djgeschichten/discokugel_animation.png') top center;
  animation-delay: 2s;
  animation: play_discokugel 4s steps(5) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes play_discokugel {
  100% {
    background-position: 0 -2995px;
  }
}
.schiller_animation {
  width: 222px;
  height: 268px;
  background: url('/static/assets/djgeschichten/schiller_animation.png') top center;
  animation-delay: 2s;
  animation: play_schiller 4s steps(5) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes play_schiller {
  100% {
    background-position: 0 -1340px;
  }
}
.lichter {
	position: absolute;
	width: 150%;
	left: -25%;
	display: block;
		
}
.lichter_animation {
  width: 2881px;
  height: 1621px;
  background: url('/static/assets/djgeschichten/lichter_animation.png') top center;
  animation-delay: 1s;
  animation: play_lichter 3s steps(4) infinite;
  /* transform: scale(0.85);
  margin-top: -65px; */
}

@keyframes play_lichter {
  100% {
    background-position: 0 -6484px;
  }
}
::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px #ac8a69;
  box-shadow: inset 0 0 0px #ac8a69;
  -webkit-border-radius: 0;
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #ac8a69;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #ac8a69;
}

::-webkit-scrollbar-button {
  background: none;
}

::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat;
}

span {
  font-family: FrozenMemory;
}

.geschichte .player {
  left: 110px !important;
}
.publikum img {
    width: 150%;
    position: absolute;
    top: -23%;
    left: -25%;
    z-index: 150;
}
</style>



// WEBPACK FOOTER //
// src/components/DJgeschichten.vue